import { useState } from 'react';

/**
 * Unghiul busolei, desfășurat într-o valoare continuă.
 *
 * Direcția vine în 0–360°, deci la trecerea peste nord (350° → 10°) diferența
 * numerică e −340: cu o tranziție CSS, acul ar face aproape un tur complet
 * înapoi în loc de cele 20° reale. Ținem minte unghiul desenat anterior și
 * adunăm mereu drumul cel mai scurt, așa că valoarea crește sau scade continuu
 * — acul alunecă pe cerc, indiferent câte treceri peste nord au fost.
 */
export function useUnwrappedAngle(angle: number): number {
  const [reported, setReported] = useState(angle);
  const [unwrapped, setUnwrapped] = useState(angle);

  // Ajustare în timpul randării, nu în efect: altfel s-ar desena întâi cadrul
  // cu unghiul vechi, iar tranziția ar porni de acolo.
  if (angle !== reported) {
    setReported(angle);
    setUnwrapped(unwrapped + shortestDelta(reported, angle));
  }

  return unwrapped;
}

/** Diferența dintre două unghiuri, adusă în intervalul (−180°, 180°]. */
function shortestDelta(from: number, to: number): number {
  const delta = (to - from) % 360;
  if (delta > 180) return delta - 360;
  if (delta <= -180) return delta + 360;
  return delta;
}
